import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { withErrorBoundary } from 'react-error-boundary';
import LogoLoader from "../../Display/LogoLoader/LogoLoader";
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorFallback = /*#__PURE__*/_jsx("div", {
  children: /*#__PURE__*/_jsx("p", {
    className: "p-2",
    children: "An unexpected error occurred. Please refresh your browser. If the issue persists, contact the Support team."
  })
});
export default function ComponentLibraryLoader(_ref) {
  let {
    loadFn,
    loadingApp,
    source,
    component = 'default',
    datadogRum = null
  } = _ref;
  return loadable(loadFn, {
    fallback: /*#__PURE__*/_jsx(LogoLoader, {
      height: 100,
      styleClass: 'flex flex-col'
    }),
    resolveComponent(components) {
      return withErrorBoundary(components[component], {
        fallback: ErrorFallback,
        onError(error, info) {
          if (datadogRum) {
            datadogRum.addError(`[${loadingApp}] [Source: '${source}'] - ${error}`, info);
          }
        }
      });
    }
  });
}
ComponentLibraryLoader.propTypes = {
  component: PropTypes.string,
  datadogRum: PropTypes.object,
  loadFn: PropTypes.func.isRequired,
  loadingApp: PropTypes.oneOf(['app-client', 'uniteus-emr']).isRequired,
  source: PropTypes.string.isRequired
};
//# sourceMappingURL=index.js.map